export default {
  pcd: "27Q",
  pname: "大阪市プレミアム",
  header: "大阪市プレミアム付商品券2023購入申込",
  explanation: "本サイトは、大阪市プレミアム付商品券2023の購入申込受付サイトです。\n購入申込方法をご案内しますので、\n以下同意したうえでメールアドレスのご登録をお願いいたします。",
  personalinfo: "ご入力いただきました個人情報は、商品券の販売のために使用いたします。\n個人情報は、法令に基づく場合を除き、ご本人様の承諾なしに第三者（弊社業務委託先を除く）に提供することはありません。",
  companyinfo: " \n株式会社EVENTIFYは大阪市プレミアム付商品券2023事業にかかる業務を大阪市から受託する事業者です。\n",
  precautions: "【2次申込対象者】\n大阪市にお住まいの方のうち、\n・1次申込されていない方\n・1次申込で1～3口当選された方（1・2次合わせて4口まで申し込み可能）\n※1次申込で4口当選された方は、お申込みできません",
  salesdatailstitles: {
    item: "利用可能価格",
},
  cid: "osakap",
  privacy: "27Q",
  terms: "27Q",
  unitdetails: "13,000円／1口",
  ticketvalue: 13000,
  unitprice: 10000,
  unitnm:"口",
  maxunits: 4,
  quantityoptions: [
      {value: "1", text: "1"},
      {value: "2", text: "2"},
      {value: "3", text: "3"},        
      {value: "4", text: "4"}
  ],
  starttime: "0:00",
  sentmsg: {
      header: "メールアドレスのご登録",
      body: {
          lines: [
              "ご登録されたメールアドレスに、購入申込URLを送信しました。",
              "現時点では購入申込は完了しておりません。",
              "ご案内メールの購入申込URLより申込み手続きを行ってください。",
              "いかなる場合でも、メールの再送はできません。\n※メールを削除または紛失した場合は、再度受付サイトにてメールアドレスの登録手続きを行ってください。"
          ]
      },
      mailnotice: {
          header: "メールが届かない場合は以下をご確認ください。",
          items:[
             "迷惑メールボックスやごみ箱フォルダに入っていないかご確認ください。",
             "上記をご確認いただき、購入申込URLが届いていない場合は、「funity-rs.jp」からメールを受信出来るように設定のうえ、再度受付サイトにてメールアドレスの登録から、手続きを行ってください。"
          ]
      }
  },
  applypageheader: "商品券の購入申込み｜申込情報入力",
  confirmpageheader: "商品券の購入申込み｜申込情報確認",
  acceptbtn: "承諾して申込",
  startdatenotice: {
      title: "申込受付に関して",
      header: "大阪市プレミアム付商品券2023申込受付に関して、以下を確認の上、申込を完了してください。",
      alert: "",
      body: "",
      danger: "",
      help: "",
      descriptions: [
          {
              term:"１. 2次申込対象者",
              definition: [
                  {text: "大阪市にお住まいの方のうち、\n"},
                  {text: "・1次申込されていない方\n"},
                  {text: "・1次申込で1～3口当選された方（1・2次合わせて4口まで申し込み可能）\n"},
                  {text: "※1次申込で4口当選された方は、お申込みできません\n"}
              ],
          },
          {
              term:"２. 当選通知",
              definition: [
                  {text: "結果は、当選者のみに、はがきにて通知いたします。\n"},
                  {text: "発送日：2024年2月5日(月)より順次発送"}
              ],
          },
          {
              term:"３. 商品券をファミリーマートにて発券・支払",
              definition:[
                  {text: "当選はがきに記載されている引換期限までにファミリーマート店舗で引き換えてください。\n"},
                  {text: "購入期間：2024年2月5日(月)～2024年2月25日(日)予定\n"},
                  {text: "発券場所：全国のファミリーマート店内のマルチコピー機にて発券\n※一部 マルチコピー機端末が設置していない店舗もございます。"}
              ]
          },
          {
            term:"４. 誓約事項",
            definition:[
              {text: "　・大阪市プレミアム商品券2023事業実施要綱を遵守すること\n"},
              {text: "　・個人情報の取扱いについて同意すること\n"},
              {text: "　・お申込み内容に虚偽のないこと\n"},
              {text: "　・大阪市が必要と判断した場合、住民登録情報との照合に同意すること\n"},
              {text: "申込と同時に誓約事項に同意したものとみなします。\n"},
              {text: "申込の前に、あらためてご確認をお願いします。\n\n"}
            ]
          },    
          {
            term:"※専用サイトより複数回お申し込みされた場合は、最後の1件を有効とします。",
            definition:[
              {text: "\n"}
            ]
          }  


        ],
      footer: ""
  },
  completemsg: {
      header: "商品券申込｜申込完了",
      body: {
          paragraphs: [
              {parts:[{text: "申込を完了しました。"}]},
              {parts:[{text: "ご登録されたメールアドレスに、申込完了通知を送信しました。"}]}
          ]
      },
      mailnotice: {
          header: "メールが届かない場合は以下をご確認ください。",
          items:[
             "迷惑メールボックスやごみ箱フォルダに入っていないかご確認ください。",
             "上記をご確認いただき、申込完了通知が届いていない場合は、「@funity-rs.jp」からメールを受信出来るように設定のうえ、再度受付サイトにてメールアドレスの登録から、手続きを行ってください。"
          ]
      },
      footer: {
          paragraphs: [
              {parts:[
                  {text: "結果は、当選者のみに、はがきにて通知いたします。\n"},
                  {text: "発送日：2024年2月5日(月)より順次発送\n"},
                  {text: "※当選はがきにはファミリーマートにて大阪市プレミアム付商品券2023が発券できる引換票番号が書かれています。\n"},
              ]}
          ]
      }
  },
  confbottomurlnm: "・大阪市プレミアム商品券2023事業実施要綱",
  confbottomurl: "https://www.funity-rs.jp/posaka2023/jishi_youkou.pdf",
  confbottomurlnm2: "・個人情報の取扱いについて",
  confbottomurl2: "https://www.funity-rs.jp/posaka2023/osaka_kojinjouhoutoriatukai2023.pdf",
  lottery: true,
  lotterypostcard:true,
  faqcontents: [
      {
          category: "よくあるお問い合わせ",
          faqs: [
            {
              q: "操作途中で、エラーが発生した時、どうすればよいのでしょうか？",
              a:
                "操作の際に「セッションの有効期限が切れています」というメッセージが出た場合は、一度ブラウザ（画面）を閉じていただき、今一度受付サイトURLにアクセスのうえ、お申込のお手続きをお進めください。",
              v: false,
            },
            {
              q: "ファミリーマートでのお支払方法について",
              a:
                "「当選はがき」で「引換票番号（13桁）」をご確認ください。\n \n4から始まる13桁の番号がファミリーマートでのお支払に必要な番号となります。\n \n 【ファミリーマートのマルチコピー機操作方法】\n \nマルチコピー機から予約済みチケット支払・発券画面へ\n ↓\n 「4************」（13 桁）を入力して、「OK」ボタンを選択\n ↓\n お支払い方法についてのご注意をご確認のうえ、「同意して利用する」ボタンをタッチ\n ↓\n お支払い内容などをご確認のうえ、よろしければ「確認」ボタンを選択\n ↓\n マルチコピー機より「マルチコピー機申込券」（レシート）が発行されます\n ↓\n 「マルチコピー機申込券」を30分以内にレジカウンターまでお持ち頂き、代金をお支払ください。\n 支払期限までにお支払いをお願いいたします。\n 全国のファミリーマート店内のマルチコピー機端末にて24時間お支払い可能です。（※一部マルチコピー機端末が設置されていない店舗もございます。）",
              v: false,
            },
            {
              q: "ファミリーマートでのお支払い期日について",
              a:
                "支払期限までにお支払いをしていただく必要があります。期限をすぎますと、申込は無効になりますのでご注意ください。",
              v: false,
            },
            {
              q: "入金発券期間について",
              a:
                "当選はがきに記載されている入金発券期間前に、チケット代金のお支払、チケットのお受け取りは出来ませんのでご注意ください。\nまた、入金発券期間内にお支払いをしていただく必要があります。期間をすぎますと、申込は無効になりますのでご注意ください。",
              v: false,
            }
          ],
        },
        {
          category: "お支払・引き取り方法について（当選者）",
          faqs: [
            {
              q: "「引換票番号」とは何の番号ですか？",
              a:
                "ファミリーマートでお支払、発券していただくための当選はがきに記載の13桁の番号（英数字）です。\n \n  【ファミリーマートのマルチコピー機操作方法】\n \nマルチコピー機から予約済みチケット支払・発券画面へ\n ↓\n 「4************」（13 桁）を入力して、「OK」ボタンを選択\n ↓\n お支払い方法についてのご注意をご確認のうえ、「同意して利用する」ボタンをタッチ\n ↓\n お支払い内容などをご確認のうえ、よろしければ「確認」ボタンを選択\n ↓\n マルチコピー機より「マルチコピー機申込券」（レシート）が発行されます\n ↓\n 「マルチコピー機申込券」を30分以内にレジカウンターまでお持ち頂き、代金をお支払ください。\n 支払期限までにお支払いをお願いいたします。\n 全国のファミリーマート店内のマルチコピー機端末にて24時間お支払い可能です。（※一部マルチコピー機端末が設置されていない店舗もございます。）",
              v: false,
            },
            {
              q: "ファミリーマートでのお支払期限を過ぎてしまった。",
              a:
                "支払期限までにお支払いいただけない場合は、お申込は無効となります。あらかじめ、ご了承ください。",
              v: false,
            },
            {
              q: "支払方法・種類について",
              a:
                "■現金　■FamiPay　■クレジットカード\n■バーコード決済（d払い／LINE Pay／PayPay／楽天ペイ／au PAY／J-Coin Pya／ゆうちょPay／メルペイ／pring／Smart Code／Alipay＋／WeChat Pay）\n■Tマネー／iD／QUICPay／PiTaPa　■ユニー商品券\n※交通系電子マネー、Edy、iD、WAON、QUOカードではお支払いただけません。\n※一部バーコード決済で一度にお支払出来る上限がある場合がございます。詳細は決済サービス提供元にお問合せください。",
              v: false,
            },
            {
              q: "ファミリーマートでのお支払方法について",
              a:
                "「当選はがき」で「引換票番号（13桁）」をご確認ください。\n \n4から始まる13桁の番号がファミリーマートでのお支払に必要な番号となります。\n \n 【ファミリーマートのマルチコピー機操作方法】\n \nマルチコピー機から予約済みチケット支払・発券画面へ\n ↓\n 「4************」（13 桁）を入力して、「OK」ボタンを選択\n ↓\n お支払い方法についてのご注意をご確認のうえ、「同意して利用する」ボタンをタッチ\n ↓\n お支払い内容などをご確認のうえ、よろしければ「確認」ボタンを選択\n ↓\n マルチコピー機より「マルチコピー機申込券」（レシート）が発行されます\n ↓\n 「マルチコピー機申込券」を30分以内にレジカウンターまでお持ち頂き、代金をお支払ください。\n 支払期限までにお支払いをお願いいたします。\n 全国のファミリーマート店内のマルチコピー機端末にて24時間お支払い可能です。（※一部マルチコピー機端末が設置されていない店舗もございます。）",
              v: false,
            },
            {
              q: "ファミリーマートでのお支払い期日について",
              a:
                "支払期限までにお支払いをしていただく必要があります。期限をすぎますと、申込は無効になりますのでご注意ください。",
              v: false,
            },
            {
              q: "どのコンビニエンスストアでも発券できますか？",
              a:
                "全国のファミリーマート店内のマルチコピー機端末にて24時間発券可能です。\n（※一部マルチコピー機端末が設置されていない店舗もございます。）",
              v: false,
            },
            {
              q: "引き取らなかったらキャンセルになりますか？",
              a:
                "支払期限までにお支払いいただけなかった場合、お申込は無効となります。あらかじめご了承ください。",
              v: false,
            },
            {
              q: "マルチコピー機申込券の有効期限はありますか？",
              a:
                "マルチコピー機より、レシートを出力後、30分を経過すると申込券レシートは無効となります。\nその場合、再度マルチコピー機を操作のうえ、レシートを出力していただき、レジカウンターにレシートをお持ちください。",
              v: false,
            },
          ],
        },
        {
          category: "サイト環境について",
          faqs: [
            {
              q: "操作途中で、エラーが発生した時、どうすればよいのでしょうか？",
              a:
                "操作の際に「セッションの有効期限が切れています」というメッセージが出た場合は、一度ブラウザ（画面）を閉じていただき、\n今一度受付サイトURLにアクセスのうえ、お申込のお手続きをお進めください。",
              v: false,
            },
            {
              q: "利用推奨環境を教えてください。",
              a: "下記のWebブラウザの最新版をご利用ください。\n \n■Webブラウザ（PC）\nGoogle chrome / Safari / Mozilla FireFox / Microsoft Edge\n\n■Webブラウザ（スマートフォン）\nGoogle chrome / Safari\n \n上記以外のWebブラウザをご利用の場合、表示が正しく行われないなどの現象が発生する可能性がありますので、ご了承ください。\nまた、当サービスではJavascriptを使用してサービス提供をしております。\nそのため、ご利用のブラウザでJavascriptを有効にしてご利用いただけますようお願いいたします。",
              v: false,
            },
          ],
        },
        {
          category: "その他",
          faqs: [
            {
              q: "定期メンテナンスはありますか？",
              a:
                "メンテナンスを行う際はサイト上で案内を致しますので、サイトにてご確認ください。",
              v: false,
            },
          ],
        },
        {
          category: "お問い合わせ",
          faqs: [
            {
              q: "申込システムについてのお問い合わせ",
              a:
                "FAQをご確認頂いても問題が解決しない場合には、お手数ですが下記サポートメールまで、お名前・お電話番号・お問い合わせ内容を明記のうえ、ご連絡ください。",
              b: {
                t: "お問い合わせフォーム",
                h:
                  "https://slib.f.msgs.jp/webapp/form/23288_slib_1/index.do?cid=osakap",
              },
              p:
                "お問い合わせの際は、｢お名前｣、「お電話番号」、「お問い合わせ内容」を明記してください。\n （返信メールが届かない際など、お電話にてご回答させていただく場合がございます。）\n ◇営業時間 10：00 ～ 18：00\n ◇上記営業時間以降のお問い合わせに関しましては、翌日以降の返信とさせていただきます。\n \n ＜問い合わせメールの返信が来ない場合＞\n 迷惑メール対策として､受信の許可･拒否などの設定をされている可能性がございます。\n 受信するには「info.eventify.co.jp」を受信するドメインとしてご登録ください｡\n メールの返信がない場合には、お客様の端末ではドメイン指定がされていません。\n 迷惑メール対策として､受信の許可･拒否などの設定を再度ご確認ください。",
              v: false,
            },
            {
              q: "大阪市プレミアム付商品券2023についてのお問い合わせ",
              a:
                "事業全体に対するお問い合わせは下記コールセンターまでご相談ください。\n\n ◇TEL  050-5538-3112\n◇営業時間   9:00～17:30　※年中無休\n\n電話でのお申込み受付はございません。",
              v: false,
            },
          ],
        },
  ]
};
